module.exports = __webpack_public_path__ + "static/media/resumeBlog2.90831d37.png";